// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aUbR","textarea":"styles_textarea__1a2fq"};